












import Vue from "vue";
import { RootState } from "./store";
import { mapState, mapActions } from "vuex";
import { LOGOUT } from "@/store/modules/AuthenticationModule/actions";

import LoadingSplashScreen from "@/components/LoadingSplashScreen.vue";
import supportedBrowsers from "../supportedBrowsers.js";

export default Vue.extend({
    components: {
        LoadingSplashScreen,
    },
    computed: {
        ...mapState({
            applicationLoaded: (state: RootState) => state.application.applicationLoaded,
            tvMode: (s: RootState) => s.application.tvMode,
            loomisStyle: (state: RootState) => state.application.startupData.brandedMode,
        }),
        isSupportedBrowser() {
            return supportedBrowsers.test(navigator.userAgent);
        },
    },
    watch: {
        $route(newVal, oldVal) {
            if (this.tvMode && newVal.path != oldVal.path) {
                console.warn(`tvMode enabled and path changing from ${oldVal.path} to ${newVal.path}.. logout`);
                this[LOGOUT]();
            }
        },
        loomisStyle: {
            handler(val) {
                if (val) {
                    let link: HTMLAnchorElement = document.querySelector("link[rel~='icon']");
                    link.href = "assets/favicon_loomis.png";
                    document.title = "Loomis Direct - Lounge";
                }
            },
            immediate: true,
        },
    },
    methods: {
        ...mapActions([LOGOUT]),
    },
});
